import { IToolboxComponentGroup } from '@shesha-io/reactjs';
//import NewComponent from '../designer-components/newComponent';
import ShaTelephonyToolboxComponent from '../designer-components/newComponent';
import CallRecordingPlayerToolboxComponent from '../designer-components/callRecordingPlayer';

export const formDesignerComponents: IToolboxComponentGroup[] = [
  {
    name: 'Telephony',
    components: [
      //NewComponent,
      ShaTelephonyToolboxComponent,
      CallRecordingPlayerToolboxComponent,
      /* NEW_COMPONENT_GOES_HERE */
    ],
    visible: true,
  },
];
